import { useState } from "react";
import Sidebar from "./sidebar";
import PluginEditor from "./pluginEditor";
import { useContext } from "react";
import { PluginsValue } from "../../contexts/plugins";
import { useParams } from "react-router-dom";
import { db } from "../../firebase";

export default function Plugins() {
  const [active, setActive] = useState(null);
  const plugins = useContext(PluginsValue);
  const { appId } = useParams();

  const updateActive = (key) => setActive(key);

  return (
    <div style={{ display: "flex", width: "100%" }} className="page">
      <Sidebar
        plugins={plugins}
        active={active}
        setActive={updateActive}
        appId={appId}
      />
      {!!active ? (
        <PluginEditor
          plugin={plugins[active]}
          setPlugin={setActive}
          id={active}
        />
      ) : null}
    </div>
  );
}
